import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { UserMgmtService } from "../user-management.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { Options } from 'ng5-slider';
@Component({
  selector: 'app-view-user-asr',
  templateUrl: './view-user-asr.component.html',
  styleUrls: ['./view-user-asr.component.css']
})
export class ViewUserASRComponent implements OnInit {

  disabled: boolean = true;
  asrUserResponseList: any;
  closeResult: string;
  userDetails: object;
  userLessonList = [];
  userId: any;
  courseId: any;
  week: any;

  AsrForm: FormGroup;
  slideForm: FormGroup;
  optionForm: FormGroup;
  physicalPercentage = 46;
  nutritionalPercentage = 50;
  introspectPercentage = 25;

  ASRReq = {
    courseId: null,
    week: null,
    observeAudioUrl: null,
    physicalQuestion: [],
    nutritionalQuestion: [],
    introspectQuestion: [],
    nextActionStepQuestion: []
  }
  asrDetail: any;

  public modalRef: NgbModalRef;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  searchText: string = "";
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
  ) { }
  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];
    this.route.queryParams.subscribe(param => {
      this.courseId = param['courseId'];
      this.week = param['week'];
    });
    this.initialiseForms();
    this.getEsrDetails(this.courseId, this.userId, this.week);

  }

  initialiseForms() {
    this.AsrForm = this.fb.group({
      week: ["", [Validators.required]],
      observeAudioUrl: ["", [Validators.required]],
      questionType: ["", [Validators.required]]
    });

    this.slideForm = this.fb.group({
      minValue: [0, [Validators.required]],
      maxValue: [0, [Validators.required]],
      defaultValue: [0, [Validators.required]],
      multiplyFactor: [0, [Validators.required]]
    });
    this.optionForm = this.fb.group({
      label: ["", [Validators.required]],
      value: ["", [Validators.required]],
      evaluationData: ["", [Validators]],
      sortOrder: ["", [Validators.required]],
      isSelected: ["", [Validators.required]],
      weightage: ["", [Validators.required]],
      iconName: ["noIcon", [Validators.required]],
      questionText: ["", [Validators.required]],
    });

  }

  getEsrDetails(courseId, userId, week) {
    let query = courseId + "/" + week + "?userId=" + userId;
    this.spinner.show();
    this.userMgmtService.getUserLesson(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.asrDetail = res.data.asrUserResponse;
        this.ASRReq.physicalQuestion = this.asrDetail.physicalQuestion;
        this.ASRReq.nutritionalQuestion = this.asrDetail.nutritionalQuestion;
        this.ASRReq.introspectQuestion = this.asrDetail.introspectQuestion;
        this.ASRReq.nextActionStepQuestion = this.asrDetail.nextActionStepQuestion;
        this.updateForm();
        this.spinner.hide();

      } else {
        this.spinner.hide();
      }
    });




  }
  updateForm() {

    this.AsrForm.patchValue({
      week: this.asrDetail.week,
      observeAudioUrl: this.asrDetail.observeAudioUrl
    });
  }
  getUserLesson(userId) {
    let query = this.courseId + "?userId=" + userId;
    this.spinner.show();
    this.userMgmtService.getUserLesson(query).subscribe(res => {

      if ((res["message"] == "Success")) {
        this.userLessonList = res.data.asrUserResponseList;
        this.spinner.hide();

      } else {
        this.userLessonList = [];
      }
    });
    this.spinner.hide();
  }


}
